@if (src(); as imageUrl) {
  <img [src]="imageUrl" [alt]="name()" [class]="sizeClass() + ' rounded-full object-cover'" />
} @else {
  <span
    [class]="
      sizeClass() +
      ' ' +
      colorClass() +
      ' inline-flex shrink-0 items-center justify-center rounded-full font-medium select-none'
    "
    [attr.aria-label]="name()"
    role="img"
  >
    {{ initials() }}
  </span>
}
